import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ExerciceDto } from "../../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { LigneVariableDto } from "../../../dto/GenApi.iNotPaie.Dto/LigneVariableDto";
import { VueBase } from "../../Controls/VueBase";
import { TriListeElementVariableEnum } from "../../../dto/GenApi.iNotPaie.Dto/TriListeElementVariableEnum";
import { ElementVariableAEditerDto } from "../../../dto/GenApi.iNotPaie.Dto/ElementVariableAEditerDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface cumulLigneJournal {
	Element: string;
	Rubrique?: string;
	Valeur: number;
}

@Component
export default class ModalVariablesTableau extends VueBase {
	public ligneVariables: LigneVariableDto[] = [];
	public ligneVariablesFiltered: LigneVariableDto[] = [];
	public exercice?: ExerciceDto = undefined;
	public cumulLigneVariables: cumulLigneJournal[] = [];
	public dataReady = true;
	public dateTraitement?: Date = undefined;
	public orderingAsc = true;
	public currentOrderColumn = "NumeroContrat";

	public Init(exercice: ExerciceDto): void {
    	this.exercice = exercice;

    	this.dateTraitement = new Date(exercice.Annee, exercice.Mois - 1);

    	this.cumulLigneVariables = [];
    	this.ligneVariables = [];
    	this.dataReady = false;
    	ServicesFactoryInstance.EditionsService.getEditionVariables(exercice, (data) => {
    		this.cumulLigneVariables = [];
    		this.ligneVariables = data;
    		this.ligneVariablesFiltered = this.ligneVariables;
    		this.dataReady = true;
    		for (let i = 0; i < this.ligneVariables.length; i++) {
    			const ligne = this.ligneVariables[i];
    			if (ligne.Element != undefined) {
    				let ligneVariableExist = this.cumulLigneVariables.filter(c => c.Element == ligne.Element)[0];
    				if (ligneVariableExist == undefined) {
    					ligneVariableExist = {
    						Element: ligne.Element,
    						Rubrique: ligne.Rubrique,
    						Valeur: ligne.Valeur as number
    					};
    					this.cumulLigneVariables.push(ligneVariableExist);
    				} else {
    					ligneVariableExist.Valeur += ligne.Valeur as number;
    				}
    			}
    		}
    		this.cumulLigneVariables = this.cumulLigneVariables.sort((a, b) => a.Element > b.Element ? 1 : -1);
    	});
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingAsc = !this.orderingAsc;
    	} else {
    		this.orderingAsc = true;
    		this.currentOrderColumn = columnName;
    	}
    	this.doOrder();
	}

	private doOrder(): void {
    	const orderingAsc = this.orderingAsc;
    	const columnName = this.currentOrderColumn;
    	if (this.ligneVariablesFiltered != undefined) {
    		this.ligneVariablesFiltered = this.ligneVariablesFiltered.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
    				return (orderingAsc ? -1 : 1);
    			}
    			if (a[columnName] > b[columnName]) {
    				return (orderingAsc ? 1 : -1);
    			}

    			return 0;
    		});
    	}
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	return (columnName == this.currentOrderColumn && this.orderingAsc == desc) ? "active" : "icons";
	}

	public annuler(): void {
    	$("#modalVariablesTableau").modal("hide");
	}

	public LancerEdition(): void {
    	$("#modalVariablesTableau").modal("hide");
    	if (this.exercice == undefined) {
    		return;
    	}
    	NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

    	const elementVariableAEditer: ElementVariableAEditerDto = {
    		Exercice: this.exercice,
    		TriListeElementVariable: this.getColonneTriee()
    	};

    	ServicesFactoryInstance.EditionsService.getEditionVariablesPdf(elementVariableAEditer, (r: Blob) => {
    		if (this.exercice == undefined) {
    			return;
    		}

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, "Eléments de calcul");
    		} else {
    			const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = "Eléments de calcul.pdf";
    			link.click();

    			NotificationServiceInstance.SendSuccess("L'édition des éléments de calcul s'est correctement déroulée !");
    		}
    	});
	}

	private getColonneTriee(): TriListeElementVariableEnum {
    	if (this.currentOrderColumn == "NumeroContrat" && this.orderingAsc) {
			return TriListeElementVariableEnum.NumeroContratCroissant;
		}

    	if (this.currentOrderColumn == "NumeroContrat" && !this.orderingAsc) {
			return TriListeElementVariableEnum.NumeroContratDecroissant;
		}

    	if (this.currentOrderColumn == "NomSalarie" && this.orderingAsc) {
			return TriListeElementVariableEnum.NomSalarieCroissant;
		}

    	if (this.currentOrderColumn == "NomSalarie" && !this.orderingAsc) {
			return TriListeElementVariableEnum.NomSalarieDecroissant;
		}

    	return TriListeElementVariableEnum.NumeroContratCroissant;
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalVariablesTableau/modalVariablesTableau.ts